module.exports = __webpack_public_path__ + "0c436c684a6837b489d01aac4947efd8.png";